import './App.css';
import { useEffect, useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMap, faTrash, faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { Squash as Hamburger } from 'hamburger-react';
import Dialog from './Dialog/Dialog';
import RouletteImage from './Images/Roulette.svg';
import CadreImage from './Images/Cadre.svg';
import Logo from './Images/Back_to_the_futur.svg';
import RouletteSpinAudio from './Audio/RouletteSpin.mp3';
import RouletteWinAudio from './Audio/RouletteWin.mp3';

import AvatarA from './Images/Groups/AvatarA.png';
import AvatarB from './Images/Groups/AvatarB.png';
import AvatarC from './Images/Groups/AvatarC.png';
import AvatarD from './Images/Groups/AvatarD.png';
import AvatarE from './Images/Groups/AvatarE.png';
import AvatarF from './Images/Groups/AvatarF.png';
import AvatarG from './Images/Groups/AvatarG.png';
import AvatarH from './Images/Groups/AvatarH.png';
import AvatarI from './Images/Groups/AvatarI.png';
import AvatarJ from './Images/Groups/AvatarJ.png';
import AvatarK from './Images/Groups/AvatarK.png';
import AvatarL from './Images/Groups/AvatarL.png';

const imageMap = {
    "AvatarA.png": AvatarA,
    "AvatarB.png": AvatarB,
    "AvatarC.png": AvatarC,
    "AvatarD.png": AvatarD,
    "AvatarE.png": AvatarE,
    "AvatarF.png": AvatarF,
    "AvatarG.png": AvatarG,
    "AvatarH.png": AvatarH,
    "AvatarI.png": AvatarI,
    "AvatarJ.png": AvatarJ,
    "AvatarK.png": AvatarK,
    "AvatarL.png": AvatarL,
};

function App() {
    const [spinDegrees, setSpinDegrees] = useState(0);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [result, setResult] = useState(null);
    const [isOpen, setIsOpen] = useState(true);
    const [groups, setGroups] = useState([]);
    const [lockedGroups, setLockedGroups] = useState({});
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const [isScreenSmall, setIsScreenSmall] = useState(false);

    const partNames = [
        { part: 1, name: "Légendes made in the 70ies" },
        { part: 2, name: "Sur la piste du disco funk" },
        { part: 3, name: "Retour vers le futur" },
        { part: 4, name: "Photo Doc Machine" },
        { part: 5, name: "Urgence à Malibu" },
        { part: 6, name: "Rembobine les 90ies" },
        { part: 7, name: "Talent Academy" },
        { part: 8, name: "Mission Cartoons" },
        { part: 9, name: "Chronoquizz 2010" },
        { part: 10, name: "Selfie stick" },
        { part: 11, name: "Check 2020" },
        { part: 12, name: "Mask and play" },
        { part: 13, name: "Retour dans le son du futur" }
    ];    

    const checkGroupCompletion = useCallback(async (groupId) => {
        try {
            const response = await fetch(`https://roulette.mediamatique.dev/Backend/Wheel.php?action=checkGroupCompletion&group_id=${groupId}`);
            const data = await response.json();
            if (data.completed) {
                setLockedGroups((prev) => ({ ...prev, [groupId]: true }));
                if (selectedGroupId === groupId) {
                    setSelectedGroupId(null);
                }
            } else {
                setLockedGroups((prev) => ({ ...prev, [groupId]: false }));
            }
        } catch (error) {
            console.error('Erreur lors de la vérification du groupe :', error);
        }
    }, [selectedGroupId]);

    useEffect(() => {
        const fetchGroups = async () => {
            try {
                const response = await fetch('https://roulette.mediamatique.dev/Backend/Wheel.php?action=getGroups');
                const data = await response.json();
                setGroups(data);
                data.forEach((group) => checkGroupCompletion(group.id));
            } catch (error) {
                console.error('Erreur lors de la récupération des groupes :', error);
            }
        };
    
        fetchGroups();
    }, [checkGroupCompletion]);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsScreenSmall(window.innerHeight < 850 || window.innerWidth < 1600);
        };
    
        window.addEventListener('resize', checkScreenSize);
        checkScreenSize();
    
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    useEffect(() => {
        if (result) {
            const timer = setTimeout(() => {
                setResult(null); 
            }, 5000);
    
            return () => clearTimeout(timer); 
        }
    }, [result]);    

    const handleGroupSelect = (groupId) => {
        if (lockedGroups[groupId]) return;
        setSelectedGroupId(groupId === selectedGroupId ? null : groupId);
    };

    const handleSpin = () => {
        if (isSpinning || !selectedGroupId) return;
        
        const AudioSpin = new Audio(RouletteSpinAudio);
        const AudioWin = new Audio(RouletteWinAudio);
    
        setIsSpinning(true);
        setResult(null);
    
        fetch('https://roulette.mediamatique.dev/Backend/Wheel.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                action: 'generateRandomPost',
                group_id: selectedGroupId,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    const postId = data.post_id;
    
                    const partAngle = 360 / 14;
                    const targetAngle = (postId - 1) * partAngle;
    
                    const currentDegrees = spinDegrees % 360;
                    const baseRotation = 360 * 5;
                    const finalRotation = baseRotation + targetAngle - currentDegrees;
    
                    AudioSpin.play();
    
                    setSpinDegrees((prev) => prev + finalRotation);
    
                    const selectedPart = partNames.find(part => part.part === postId);
                    const selectedName = selectedPart ? selectedPart.name : `Part ${postId}`;
    
                    fetch('https://roulette.mediamatique.dev/Backend/Wheel.php', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            action: 'assignPost',
                            group_id: selectedGroupId,
                            post_id: postId,
                        }),
                    })
                        .then((assignResponse) => assignResponse.json())
                        .catch((error) => {
                            console.error('Erreur réseau lors de l\'insertion dans history :', error);
                        });
    
                    setTimeout(() => {
                        setResult(selectedName);
                        setIsSpinning(false);
                        checkGroupCompletion(selectedGroupId);
                        setSelectedGroupId(null);
                        AudioWin.play();
                    }, 5000);
                } else {
                    console.error('Erreur :', data.error);
                    setIsSpinning(false);
                }
            })
            .catch((error) => {
                console.error('Erreur réseau :', error);
                setIsSpinning(false);
            });
    };  
    
    const handleReset = async () => {
        const confirmation = window.confirm("Êtes-vous sûr de vouloir réinitialiser la roulette ?");
        console.log("Confirmation de l'utilisateur :", confirmation);
    
        if (!confirmation) {
            console.log("Réinitialisation annulée par l'utilisateur.");
            return;
        }
    
        try {
            const response = await fetch('https://roulette.mediamatique.dev/Backend/Wheel.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'clearHistory' })
            });
    
            const data = await response.json();
            console.log("Réponse de l'API :", data);
    
            if (data.success) {
                alert('La roulette a été réinitialisée avec succès.');
                setLockedGroups({});
                setSelectedGroupId(null);
                setSpinDegrees(0);
            } else {
                console.error('Erreur :', data.error);
                alert('Erreur lors de la réinitialisation : ' + data.error);
            }
        } catch (error) {
            console.error('Erreur réseau :', error);
            alert('Erreur réseau lors de la réinitialisation.');
        }
    };      
    
    const handleOpenDialog = () => {
        setIsDialogOpen(true);
        setIsOpen(false);
    };
    
    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setIsOpen(true);
    };
    
    return (
        <>
            {isScreenSmall ? (
                <div className="resize">
                    <p>L'écran n'est pas adapté pour afficher la roulette</p>
                </div>
            ) : (
                <div className="background">
                    <img className='logo' src={Logo} alt="Logo de retour vers le futur" />
                    <div className="container-roulette">
                        <div className="roulette">
                            <motion.img
                                className="img_roulette"
                                src={RouletteImage}
                                alt="Fond roulette"
                                animate={{ rotate: spinDegrees }}
                                transition={{
                                    duration: 5,
                                    ease: [0.25, 0.1, 0.25, 1],
                                }}
                            />
                            <img className="img_cadre" src={CadreImage} alt="Cadre roulette" />
                        </div>

                        <div className='container-button'>
                            <div className="container-btn-start">
                                <span>
                                    <FontAwesomeIcon icon={selectedGroupId && !lockedGroups[selectedGroupId] ? faLockOpen : faLock} />
                                </span>
                                <button
                                    className='btn-start'
                                    onClick={handleSpin}
                                    disabled={!selectedGroupId || isSpinning || lockedGroups[selectedGroupId]}
                                >
                                    {isSpinning ? "Roulette en cours..." : "Lancer la roulette"}
                                </button>
                            </div>

                            <button className='btn-plan' onClick={handleOpenDialog}>
                                <FontAwesomeIcon className='icon' icon={faMap} /> Planification
                            </button>

                            <button className='btn-reset' onClick={handleReset}>
                                <FontAwesomeIcon className='icon' icon={faTrash} /> Réinitialiser
                            </button>
                        </div>
                        
                        <div className="btn-menu">
                            <Hamburger 
                                toggled={isOpen} 
                                toggle={setIsOpen} 
                                color={isOpen ? "#fff" : "#000"}
                            />
                        </div>
                    </div>

                    <motion.header
                        initial={{ x: "100%" }}
                        animate={{ x: isOpen ? "0%" : "100%" }}
                        transition={{ duration: 0.5, ease: "easeInOut" }}
                        className="header"
                    >
                        <span className='space'></span>
                        <ul>
                            {groups.map((group) => (
                                <div
                                    key={group.id}
                                    className={`group ${selectedGroupId === group.id ? 'selected' : ''} ${lockedGroups[group.id] ? 'locked' : ''}`}
                                    onClick={() => handleGroupSelect(group.id)}
                                >
                                    <img src={imageMap[`${group.image}.png`]} alt={group.name} />
                                    <li style={{ textDecoration: lockedGroups[group.id] ? 'line-through' : 'none' }}>
                                        {group.name}
                                    </li>
                                </div>
                            ))}
                        </ul>
                    </motion.header>

                    <h6>Réalisé par la section Médiamatique - Maxime Séchaud</h6>

                    {result && (
                        <AnimatePresence>
                            <motion.div
                                className='background-message'
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5 }}
                            >
                                <motion.div
                                    className='message'
                                    initial={{ scale: 0.8 }}
                                    animate={{ scale: 1 }}
                                    exit={{ scale: 0.8 }}
                                    transition={{ duration: 0.5 }}
                                >
                                    <p><span>Dirigez-vous au poste</span><br />"{result}"</p>
                                    <div className="progress-bar-container">
                                        <motion.div
                                            className="progress-bar"
                                            initial={{ width: 0 }}
                                            animate={{ width: "100%" }}
                                            transition={{ duration: 5 }}
                                        />
                                    </div>
                                </motion.div>
                            </motion.div>
                        </AnimatePresence>
                    )}

                </div>
            )}

            <AnimatePresence>
                {isDialogOpen && <Dialog onClose={handleCloseDialog} />}
            </AnimatePresence>
        </>
    );
}

export default App;
